import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLogActivityByUserComponent from "../../../components/Admin/users/AdminLogActivityByUserComponent";

const AdminLogActivityByUserPage = () => {
    const params = useParams()
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <AdminLogActivityByUserComponent
        userId={ params.userId }
        shouldRedirect={ () => redirect() }
    />;
}

export default AdminLogActivityByUserPage;